import { isNative } from '../platform';

// Enum keys match the exported Capacitor enum (PascalCase)
type ImpactStyleKey      = 'Light' | 'Medium' | 'Heavy';
type NotificationTypeKey = 'Success' | 'Warning' | 'Error';

async function impact(style: ImpactStyleKey): Promise<void> {
  if (!isNative) return;
  try {
    const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
    await Haptics.impact({ style: ImpactStyle[style] });
  } catch { /* ignore */ }
}

async function notification(type: NotificationTypeKey): Promise<void> {
  if (!isNative) return;
  try {
    const { Haptics, NotificationType } = await import('@capacitor/haptics');
    await Haptics.notification({ type: NotificationType[type] });
  } catch { /* ignore */ }
}

export const haptics = {
  /** Sign selection, button taps, chip selection */
  light:   (): Promise<void> => impact('Light'),
  /** Tarot card flip, form submission */
  medium:  (): Promise<void> => impact('Medium'),
  /** Score reveal (AstroMatch, Sinastria) */
  heavy:   (): Promise<void> => impact('Heavy'),
  /** Payment confirmed, reading generated */
  success: (): Promise<void> => notification('Success'),
  /** Credit depleted, error state */
  warning: (): Promise<void> => notification('Warning'),
};
